import React from 'react'
import {
  type ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

import { Button } from '~components/internal'

interface DeleteChatDialogProps {
  open: boolean
  onConfirm: () => void
  onClose: () => void
  title: string
  message?: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  confirmColor?: ButtonProps['color']
}

const DeleteChatDialog: React.FC<DeleteChatDialogProps> = ({
  open,
  onConfirm,
  onClose,
  title,
  message = '',
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  confirmColor = 'error',
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent sx={{ pb: 1 }}>
      {message && <DialogContentText>{message}</DialogContentText>}
    </DialogContent>
    <DialogActions sx={{ borderTop: 'none' }}>
      <Button variant='outlined' onClick={onClose}>
        {cancelLabel}
      </Button>
      <Button color={confirmColor} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
)

export default DeleteChatDialog
